import * as requestFromServer from "./UserChildsCrud";
import { userChildsSlice, callTypes } from "../../UserChildsSlice";

const { actions } = userChildsSlice;

export const fetch = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .find(queryParams)
    .then((response) => {
      const entities = response.data;
      const totalCount = response.data.length;

      dispatch(actions.childsFetched({ totalCount, entities }));
      // dispatch(actions.catchError({ error, callType: callTypes.list }));
    })
    .catch((error) => {
      error.clientMessage = error.response.data;

      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUnAssignedAccounts = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findUnAssignedAccounts(queryParams)
    .then((response) => {
      for (let index = 0; index < response.data.length; index++) {
        response.data[index].id = response.data[index]._id;
      }

      const entities = response.data;
      const totalCount = response.data.length;

      dispatch(actions.childsFetched({ totalCount, entities }));
      // dispatch(actions.catchError({ error, callType: callTypes.list }));
    })
    .catch((error) => {
      error.clientMessage = error.response.data;

      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
